import styled from '@emotion/styled';

import Box from '~/common/components/Box';
import Text from '~/common/components/Texts/Text';
import { RULE_CATEGORY_ID } from '~/common/constants';
import CalculationHistory from '~/pages/IncomeCalculator/CalculationHistory/CalculationHistory';
import { CalculationTypes } from '~/pages/IncomeCalculator/enums';
import { useSelectedAlert } from '~/stores/navigationStore';

const StyledHeader = styled(Box)<{ isWriteAccessDisabled?: boolean }>(
  (props) => ({
    boxSizing: 'border-box',
    minHeight: '72px',
    display: 'flex',
    alignItems: 'center',
    padding: '0 32px 0 32px',
    borderBottom: `1px solid ${props.theme.colors?.gray[100]}`,
    opacity: props.isWriteAccessDisabled ? 0.6 : 1,
  }),
);

type HeaderProps = {
  heading?: string;
  isWriteAccessDisabled?: boolean;
};

const Header = ({ heading, isWriteAccessDisabled }: Readonly<HeaderProps>) => {
  const { ruleCategoryId, additionalReferences } = useSelectedAlert();

  const shouldShowCalculationHistory =
    ruleCategoryId === RULE_CATEGORY_ID.INCOME &&
    (additionalReferences?.IsSDUI === 'True' ||
      additionalReferences?.CalculatorTypeId ==
        CalculationTypes.PayStub.toString());

  if (!heading) {
    return null;
  }

  return (
    <StyledHeader as={'header'} isWriteAccessDisabled={isWriteAccessDisabled}>
      <Text w="100%" as="h2">
        {heading}
      </Text>
      {shouldShowCalculationHistory && (
        <CalculationHistory sx={{ marginRight: '.5rem' }} />
      )}
    </StyledHeader>
  );
};

export default Header;
